import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { CopyToClipboard } from 'react-copy-to-clipboard';

import './CopyValue.scss';

const propTypes = {
  value: PropTypes.node.isRequired,
  iconOnly: PropTypes.bool,
};
const defaultProps = {
  iconOnly: false,
};
const copyIcon = require('./assets/copy.png');

class CopyValue extends Component {
  notify = () => toast('👌 Copied to clipboard', {
    position: toast.POSITION.BOTTOM_CENTER,
    closeButton: false,
    autoClose: 5000,
    hideProgressBar: true,

  });
  render() {
    const { value, iconOnly } = this.props;
    return (
      <div
        className="copy-value-wrapper"
      >
        <ToastContainer />

        <CopyToClipboard
          text={value}
          onCopy={() => { this.notify(); }}
        >

          <span>{!iconOnly && value}  <img src={copyIcon} alt="copy-icon" /> </span>
        </CopyToClipboard>
      </div>);
  }
}


CopyValue.propTypes = propTypes;
CopyValue.defaultProps = defaultProps;


export default CopyValue;



// WEBPACK FOOTER //
// ./src/components/_molecules/CopyValue/CopyValue.js